import * as types from '../mutation-types'
const state = {
	categories: []
}

const actions = {
	fetchAllCategories ({ commit }) {
		return window.axios.get('/categories').then((response) => {
			commit(types.STORE_CATEGORIES, response.data)
			return response.data
		})
	},

	fetchProductsByCategory ({ commit }, { category }) {
		return window.axios.get(`/categories/${category}/products`)
	}
}

const mutations = {
	[types.STORE_CATEGORIES] (state, categories) {
		state.categories = categories;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}